module.exports = __webpack_public_path__ + "static/media/card.e6fecbf3.svg";